export default __webpack_public_path__ + "static/mobile-nav-big-d9f4402b7dfbd0e14deb15e953cc3dd3.jpg";